// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { DashboardOfflineTrafficModule } from './modules/dashboard-offline-traffic/dashboard-offline-traffic.module';
import { IconTooltipModule } from '@coa/app/shared/icon-tooltip/icon-tooltip.module';
import { SelectClientListModule } from '@coa/app/shared/select-client-list/select-client-list.module';
import { DashboardSummaryModule } from './modules/dashboard-summary/dashboard-summary.module';
import { SelectCategoryModule } from '@coa/app/shared/filters/select-category/select-category.module';
import { SelectDateRangeModule } from '@coa/app/shared/filters/select-date-range/select-date-range.module';
import { DashboardGroupsModule } from './modules/dashboard-groups/dashboard-groups.module';
import { DashboardFloorsModule } from '@coa/app/home/modules/dashboard/modules/dashboard-floors/dashboard-floors.module';
import { DashboardLocationPreferencesModule } from '@coa/app/home/modules/dashboard/modules/dashboard-location-preferences/dashboard-location-preferences.module';
import { DashboardHeaderComponent } from './components/dashboard-header/dashboard-header.component';
import { FeatureToggleModule } from '@coa/app/shared/feature-toggle/feature-toggle.module';
import { DashboardContentComponent } from './components/dashboard-content/dashboard-content.component';
import { HeadingModule } from '@coa/app/shared/heading/heading.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    FormsModule,
    RouterModule,
    MatPaginatorModule,
    DashboardRoutingModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    DashboardOfflineTrafficModule,
    IconTooltipModule,
    SelectClientListModule,
    DashboardSummaryModule,
    SelectCategoryModule,
    SelectDateRangeModule,
    DashboardGroupsModule,
    DashboardFloorsModule,
    DashboardLocationPreferencesModule,
    FeatureToggleModule,
    HeadingModule,
  ],
  declarations: [
    DashboardComponent,
    DashboardHeaderComponent,
    DashboardContentComponent,
  ],
})
export class DashboardModule {
}
